import React, { useEffect, useState, useMemo } from 'react';
import { supabase } from '../supabase';
import Header from '../components/Header';

const C = {
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  attivita: '#FF5B00',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e5e7eb',
  light: '#f5f7fa',
};

const MAX_FIELDS = 5;

export default function Bacheca() {
  const [esperienze, setEsperienze] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usernames, setUsernames] = useState(['']);
  const [destinazioni, setDestinazioni] = useState(['']);

  useEffect(() => {
    const carica = async () => {
      const { data } = await supabase
        .from('esperienze')
        .select('*, profiles(username)')
        .eq('is_pubblica', true)
        .order('volte_copiata', { ascending: false });
      setEsperienze(data || []);
      setLoading(false);
    };
    carica();
  }, []);

  const addUsername = () => { if (usernames.length < MAX_FIELDS) setUsernames(p => [...p, '']); };
  const setUsername = (i, val) => setUsernames(p => p.map((u, idx) => idx === i ? val : u));
  const removeUsername = (i) => setUsernames(p => p.filter((_, idx) => idx !== i));

  const addDest = () => { if (destinazioni.length < MAX_FIELDS) setDestinazioni(p => [...p, '']); };
  const setDest = (i, val) => setDestinazioni(p => p.map((d, idx) => idx === i ? val : d));
  const removeDest = (i) => setDestinazioni(p => p.filter((_, idx) => idx !== i));

  const filtrate = useMemo(() => {
    const activeUsers = usernames.filter(u => u.trim());
    const activeDest = destinazioni.filter(d => d.trim());
    return esperienze.filter(e => {
      const matchUser = activeUsers.length === 0 ||
        activeUsers.some(u => e.profiles?.username?.toLowerCase().includes(u.toLowerCase()));
      const matchDest = activeDest.length === 0 ||
        activeDest.some(d =>
          e.destinazione?.toLowerCase().includes(d.toLowerCase()) ||
          e.titolo?.toLowerCase().includes(d.toLowerCase())
        );
      return matchUser && matchDest;
    });
  }, [esperienze, usernames, destinazioni]);

  const hasFilter = usernames.some(u => u.trim()) || destinazioni.some(d => d.trim());

  const scrollToResults = () => {
    document.getElementById('octa-results')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        button { cursor: pointer; font-family: 'Roboto', sans-serif; }
        button:hover { opacity: 0.85; }
        input { font-family: 'Roboto', sans-serif; }
        input:focus { outline: none; border-color: ${C.alloggio} !important; }
        input::placeholder { color: #b0b7c3; }
        .octa-hamburger { display: none; }
        @media (max-width: 1024px) {
          .octa-header { padding: 12px 24px !important; }
          .octa-main-b { padding: 32px 24px !important; }
          .octa-footer { padding: 24px 32px !important; }
        }
        @media (max-width: 768px) {
          .octa-hamburger { display: flex !important; align-items: center; }
          .octa-header { padding: 12px 16px !important; }
          .octa-nav-link { display: none !important; }
          .octa-search-3col { flex-direction: column !important; }
          .octa-search-divider { display: none !important; }
          .octa-main-b { padding: 24px 16px !important; }
          .octa-footer { padding: 24px 16px !important; flex-direction: column !important; align-items: flex-start !important; }
        }
      `}</style>

      <Header bg={C.dark} />

      {/* TITLE + SEARCH PANEL */}
      <div style={{ backgroundColor: C.white, borderBottom: `1px solid ${C.border}` }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '40px 40px 0', textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '16px' }}>
            {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
              <div key={k} style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: C[k] }} />
            ))}
          </div>
          <h1 style={{ fontSize: '42px', fontWeight: 900, color: C.text, marginBottom: '12px' }}>Bacheca Esperienze</h1>
          <p style={{ fontSize: '16px', color: C.textLight, marginBottom: '36px' }}>
            Cerca e usa come base il viaggio di un'altra persona, confronta più destinazioni.
          </p>
        </div>

        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 40px 40px' }}>
          <div className="octa-search-3col" style={{ display: 'flex', gap: '0', alignItems: 'stretch' }}>

            {/* COLONNA SINISTRA — UTENTI */}
            <div style={{ flex: 1, paddingRight: '40px' }}>
              <p style={{ fontSize: '16px', fontWeight: 700, color: C.text, marginBottom: '16px' }}>
                Cerca per nome utente
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {usernames.map((val, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ flex: 1, position: 'relative' }}>
                      <span style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#b0b7c3', fontSize: '14px', pointerEvents: 'none' }}>🔍</span>
                      <input
                        type="text"
                        value={val}
                        onChange={e => setUsername(i, e.target.value)}
                        placeholder="es. Federico93"
                        style={{ width: '100%', padding: '11px 16px 11px 38px', borderRadius: '4px', border: `1px solid ${C.border}`, backgroundColor: C.white, color: C.text, fontSize: '14px' }}
                      />
                    </div>
                    {usernames.length > 1 && (
                      <button onClick={() => removeUsername(i)} style={{ width: '28px', height: '28px', borderRadius: '50%', border: `1px solid ${C.border}`, backgroundColor: C.white, color: C.textLight, fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>×</button>
                    )}
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '14px' }}>
                {usernames.length < MAX_FIELDS ? (
                  <button onClick={addUsername} style={{ background: 'none', border: 'none', color: C.textLight, fontSize: '13px', fontWeight: 600, padding: 0, display: 'flex', alignItems: 'center', gap: '4px' }}>
                    Aggiungi utente <span style={{ fontSize: '18px', lineHeight: 1, color: C.alloggio }}>+</span>
                  </button>
                ) : <span />}
                <button onClick={scrollToResults} style={{ padding: '10px 22px', borderRadius: '50px', backgroundColor: C.dark, color: C.white, fontSize: '13px', fontWeight: 700, border: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  CERCA <span style={{ fontSize: '12px' }}>›</span>
                </button>
              </div>
            </div>

            {/* DIVIDER */}
            <div className="octa-search-divider" style={{ width: '1px', backgroundColor: C.border, margin: '0 8px', flexShrink: 0 }} />

            {/* COLONNA CENTRO — CTA */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0 40px', textAlign: 'center', gap: '20px' }}>
              <p style={{ fontSize: '16px', fontWeight: 700, color: C.text, lineHeight: 1.4 }}>
                Non sai quando partire<br />o dove andare?
              </p>
              <button
                onClick={() => { setUsernames(['']); setDestinazioni(['']); scrollToResults(); }}
                style={{ padding: '14px 28px', borderRadius: '50px', backgroundColor: C.attivita, color: C.white, fontSize: '15px', fontWeight: 700, border: 'none', whiteSpace: 'nowrap' }}
              >
                Scopri le proposte migliori
              </button>
            </div>

            {/* DIVIDER */}
            <div className="octa-search-divider" style={{ width: '1px', backgroundColor: C.border, margin: '0 8px', flexShrink: 0 }} />

            {/* COLONNA DESTRA — DESTINAZIONI */}
            <div style={{ flex: 1, paddingLeft: '40px' }}>
              <p style={{ fontSize: '16px', fontWeight: 700, color: C.text, marginBottom: '16px' }}>
                Sai dove andare?
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {destinazioni.map((val, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ flex: 1, position: 'relative' }}>
                      <span style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#b0b7c3', fontSize: '14px', pointerEvents: 'none' }}>🔍</span>
                      <input
                        type="text"
                        value={val}
                        onChange={e => setDest(i, e.target.value)}
                        placeholder="es. Tokyo, Madrid..."
                        style={{ width: '100%', padding: '11px 16px 11px 38px', borderRadius: '4px', border: `1px solid ${C.border}`, backgroundColor: C.white, color: C.text, fontSize: '14px' }}
                      />
                    </div>
                    {destinazioni.length > 1 && (
                      <button onClick={() => removeDest(i)} style={{ width: '28px', height: '28px', borderRadius: '50%', border: `1px solid ${C.border}`, backgroundColor: C.white, color: C.textLight, fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>×</button>
                    )}
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '14px' }}>
                {destinazioni.length < MAX_FIELDS ? (
                  <button onClick={addDest} style={{ background: 'none', border: 'none', color: C.textLight, fontSize: '13px', fontWeight: 600, padding: 0, display: 'flex', alignItems: 'center', gap: '4px' }}>
                    Aggiungi luogo <span style={{ fontSize: '18px', lineHeight: 1, color: C.attivita }}>+</span>
                  </button>
                ) : <span />}
                <button onClick={scrollToResults} style={{ padding: '10px 22px', borderRadius: '50px', backgroundColor: C.dark, color: C.white, fontSize: '13px', fontWeight: 700, border: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  CERCA <span style={{ fontSize: '12px' }}>›</span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* RISULTATI */}
      <main id="octa-results" className="octa-main-b" style={{ padding: '40px', maxWidth: '1100px', margin: '0 auto' }}>
        {loading ? (
          <p style={{ textAlign: 'center', color: C.textLight, padding: '60px 0' }}>Caricamento...</p>
        ) : filtrate.length === 0 ? (
          <EmptyState hasFilter={hasFilter} />
        ) : (
          <>
            <p style={{ fontSize: '14px', color: C.textLight, marginBottom: '24px' }}>
              {filtrate.length} {filtrate.length === 1 ? 'esperienza trovata' : 'esperienze trovate'}
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px' }}>
              {filtrate.map(e => <CardEsperienza key={e.id} e={e} />)}
            </div>
          </>
        )}
      </main>

      {/* FOOTER */}
      <footer className="octa-footer" style={{ padding: '32px 40px', borderTop: `1px solid rgba(255,255,255,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.dark, flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>
    </div>
  );
}

function CardEsperienza({ e }) {
  const segmenti = [
    { key: 'trasporto', color: C.trasporto, label: 'Trasporto' },
    { key: 'alloggio', color: C.alloggio, label: 'Alloggio' },
    { key: 'attivita', color: C.attivita, label: 'Attività' },
    { key: 'servizi', color: C.servizi, label: 'Servizi' },
  ].filter(s => e[s.key]);

  return (
    <div style={{ backgroundColor: C.white, borderRadius: '16px', border: `1px solid ${C.border}`, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', height: '5px' }}>
        {segmenti.map(s => <div key={s.key} style={{ flex: 1, backgroundColor: s.color }} />)}
      </div>
      <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '12px', flex: 1 }}>
        <div>
          <p style={{ fontSize: '11px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Destinazione</p>
          <h3 style={{ fontSize: '20px', fontWeight: 900, color: C.text }}>{e.destinazione || '—'}</h3>
        </div>
        {e.titolo && <p style={{ fontSize: '14px', color: C.textLight, lineHeight: 1.4 }}>{e.titolo}</p>}
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {e.durata_notti && <span style={s.badge}>🌙 {e.durata_notti} notti</span>}
          {e.num_adulti && <span style={s.badge}>👤 {e.num_adulti} adult{e.num_adulti === 1 ? 'o' : 'i'}</span>}
          {e.prezzo_totale && <span style={{ ...s.badge, backgroundColor: '#f0fdf4', color: '#15803d', fontWeight: 700 }}>€ {Number(e.prezzo_totale).toLocaleString('it-IT')}</span>}
        </div>
        {segmenti.length > 0 && (
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {segmenti.map(s => <span key={s.key} style={{ padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 700, color: C.white, backgroundColor: s.color }}>{s.label}</span>)}
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 'auto', paddingTop: '12px', borderTop: `1px solid ${C.border}` }}>
          <span style={{ fontSize: '12px', color: C.textLight }}>
            di <strong>{e.profiles?.username || 'utente'}</strong>
            {e.volte_copiata > 0 && ` · ${e.volte_copiata} copie`}
          </span>
          <a href={`/pacchetto/${e.slug}`} style={{ padding: '7px 14px', borderRadius: '8px', backgroundColor: C.dark, color: C.white, fontSize: '12px', fontWeight: 700, border: 'none', textDecoration: 'none', display: 'inline-block' }}>
            Dettagli →
          </a>
        </div>
      </div>
    </div>
  );
}

function EmptyState({ hasFilter }) {
  return (
    <div style={{ textAlign: 'center', padding: '80px 20px' }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>🗺️</div>
      <h2 style={{ fontSize: '22px', fontWeight: 900, color: C.text, marginBottom: '8px' }}>
        {hasFilter ? 'Nessun risultato' : 'Ancora nessuna esperienza'}
      </h2>
      <p style={{ fontSize: '15px', color: C.textLight, marginBottom: '32px' }}>
        {hasFilter
          ? 'Nessuna esperienza corrisponde ai filtri inseriti'
          : 'Sii il primo a condividere un viaggio con la community OCTA'}
      </p>
      {!hasFilter && (
        <a href="/crea" style={{ display: 'inline-block', padding: '14px 28px', borderRadius: '10px', backgroundColor: C.alloggio, color: C.white, fontSize: '15px', fontWeight: 700, textDecoration: 'none' }}>
          + Crea la prima esperienza
        </a>
      )}
    </div>
  );
}

const s = {
  badge: { padding: '4px 10px', borderRadius: '6px', backgroundColor: '#f1f5f9', color: C.text, fontSize: '12px' },
};
